import FileSize from "../../../components/FileSize";
import ThreatStatusLabel from "../../../components/ThreatStatusLabel";
import { ExpandedLocalDetails } from "../../samples/@types/expanded_local_details";
import {
  matrixValuesFromDetails,
  referenceCellText
} from "../differenceMatrixFields";
import styles from "./compare-samples.module.scss";

interface SampleCardProps {
  role: string;
  details: ExpandedLocalDetails;
}

const SampleCard = ({ role, details }: SampleCardProps): JSX.Element => {
  const { sample, source, relationship } = details;
  const values = matrixValuesFromDetails(details);
  // For an extracted file `source` is its container.
  const fileName = relationship?.filepath || source?.filename;

  return (
    <div className={styles.card}>
      <div className={styles["card-head"]}>
        <ThreatStatusLabel threatStatus={sample.classification} showColor />
        <span className={styles["card-role"]}>{role}</span>
      </div>
      <div className={styles["card-hash"]}>{sample.sha1}</div>
      <div className={styles["card-filename"]}>{fileName}</div>
      <div className={styles["card-meta"]}>
        <span>{referenceCellText("file_type", values)}</span>
        <span>{referenceCellText("extracted_files", values)} files</span>
        <span>
          <FileSize value={sample.file_size} />
        </span>
      </div>
    </div>
  );
};

export default SampleCard;
